import type { Order, MenuCategory, Customer, DashboardMetrics, Reservation } from '../types';

// ─── MOCK DATA ─────────────────────────────────────────────────────────────

export const mockCategories: MenuCategory[] = [
    {
        id: '1', name: 'Entradas', order: 1, active: true,
        products: [
            { id: 'p1', categoryId: '1', name: 'Bruschetta Clássica', description: 'Pão tostado com tomate, alho e manjericão fresco', price: 28.90, available: true, preparationTime: 10, tags: ['vegetariano'] },
            { id: 'p2', categoryId: '1', name: 'Carpaccio de Filé', description: 'Fatias finas de filé mignon, rúcula e parmesão', price: 48.90, available: true, preparationTime: 8 },
            { id: 'p3', categoryId: '1', name: 'Bolinho de Bacalhau', description: 'Sequinhos por fora, cremosos por dentro (6 unidades)', price: 36.90, available: true, preparationTime: 15 },
        ]
    },
    {
        id: '2', name: 'Pratos Principais', order: 2, active: true,
        products: [
            { id: 'p4', categoryId: '2', name: 'Filé ao Molho Madeira', description: 'Filé mignon grelhado com molho madeira e arroz', price: 89.90, available: true, preparationTime: 25 },
            { id: 'p5', categoryId: '2', name: 'Risoto de Camarão', description: 'Camarões frescos, arroz arbóreo, limão siciliano', price: 78.90, available: true, preparationTime: 30 },
            { id: 'p6', categoryId: '2', name: 'Frango Grelhado', description: 'Filé de frango, legumes salteados e purê de batata', price: 62.90, available: false, preparationTime: 20 },
        ]
    },
    {
        id: '3', name: 'Bebidas', order: 3, active: true,
        products: [
            { id: 'p7', categoryId: '3', name: 'Suco Natural 500ml', description: 'Laranja, Limão, Abacaxi ou Maracujá', price: 14.90, available: true, preparationTime: 5 },
            { id: 'p8', categoryId: '3', name: 'Refrigerante Lata', description: 'Coca-Cola, Guaraná, Sprite', price: 8.90, available: true, preparationTime: 2 },
            { id: 'p9', categoryId: '3', name: 'Água Mineral 500ml', description: 'Com ou sem gás', price: 6.90, available: true, preparationTime: 1 },
        ]
    },
    {
        id: '4', name: 'Sobremesas', order: 4, active: true,
        products: [
            { id: 'p10', categoryId: '4', name: 'Petit Gateau', description: 'Bolinho quente de chocolate com sorvete de baunilha', price: 32.90, available: true, preparationTime: 15 },
            { id: 'p11', categoryId: '4', name: 'Pudim Caseiro', description: 'Pudim de leite condensado com calda de caramelo', price: 22.90, available: true, preparationTime: 5 },
        ]
    },
];

export const mockOrders: Order[] = [
    { id: 'ord-001', establishmentId: 'est-1', status: 'pending', type: 'table', tableNumber: '5', customerName: 'João Silva', items: [{ id: 'i1', productId: 'p4', productName: 'Filé ao Molho Madeira', productPrice: 89.90, quantity: 2, subtotal: 179.80 }, { id: 'i2', productId: 'p7', productName: 'Suco Natural 500ml', productPrice: 14.90, quantity: 2, subtotal: 29.80 }], subtotal: 209.60, total: 209.60, createdAt: new Date(Date.now() - 5 * 60000).toISOString(), updatedAt: new Date().toISOString() },
    { id: 'ord-002', establishmentId: 'est-1', status: 'preparing', type: 'table', tableNumber: '2', customerName: 'Maria Oliveira', items: [{ id: 'i3', productId: 'p5', productName: 'Risoto de Camarão', productPrice: 78.90, quantity: 1, subtotal: 78.90 }], subtotal: 78.90, total: 78.90, estimatedTime: 15, createdAt: new Date(Date.now() - 18 * 60000).toISOString(), updatedAt: new Date().toISOString() },
    { id: 'ord-003', establishmentId: 'est-1', status: 'ready', type: 'counter', customerName: 'Pedro Alves', items: [{ id: 'i4', productId: 'p1', productName: 'Bruschetta Clássica', productPrice: 28.90, quantity: 2, subtotal: 57.80 }, { id: 'i5', productId: 'p8', productName: 'Refrigerante Lata', productPrice: 8.90, quantity: 2, subtotal: 17.80 }], subtotal: 75.60, total: 75.60, createdAt: new Date(Date.now() - 30 * 60000).toISOString(), updatedAt: new Date().toISOString() },
    { id: 'ord-004', establishmentId: 'est-1', status: 'pending', type: 'delivery', customerName: 'Ana Costa', customerPhone: '(11) 98765-4321', deliveryAddress: 'Rua das Flores, 123', items: [{ id: 'i6', productId: 'p10', productName: 'Petit Gateau', productPrice: 32.90, quantity: 1, subtotal: 32.90 }], subtotal: 32.90, total: 32.90, createdAt: new Date(Date.now() - 3 * 60000).toISOString(), updatedAt: new Date().toISOString() },
    { id: 'ord-005', establishmentId: 'est-1', status: 'confirmed', type: 'table', tableNumber: '8', customerName: 'Carlos Mendes', items: [{ id: 'i7', productId: 'p2', productName: 'Carpaccio de Filé', productPrice: 48.90, quantity: 1, subtotal: 48.90 }, { id: 'i8', productId: 'p4', productName: 'Filé ao Molho Madeira', productPrice: 89.90, quantity: 2, subtotal: 179.80 }], subtotal: 228.70, total: 228.70, createdAt: new Date(Date.now() - 12 * 60000).toISOString(), updatedAt: new Date().toISOString() },
];

export const mockCustomers: Customer[] = [
    { id: 'c1', name: 'João Silva', email: 'joao@email.com', phone: '(11) 99999-1111', totalOrders: 12, totalSpent: 1840.50, lastOrderAt: new Date(Date.now() - 2 * 86400000).toISOString(), createdAt: new Date(Date.now() - 90 * 86400000).toISOString() },
    { id: 'c2', name: 'Maria Oliveira', email: 'maria@email.com', phone: '(11) 99999-2222', totalOrders: 8, totalSpent: 920.80, lastOrderAt: new Date(Date.now() - 1 * 86400000).toISOString(), createdAt: new Date(Date.now() - 60 * 86400000).toISOString() },
    { id: 'c3', name: 'Pedro Alves', email: 'pedro@email.com', phone: '(11) 99999-3333', totalOrders: 5, totalSpent: 450.20, lastOrderAt: new Date(Date.now() - 5 * 86400000).toISOString(), createdAt: new Date(Date.now() - 45 * 86400000).toISOString() },
    { id: 'c4', name: 'Ana Costa', email: 'ana@email.com', phone: '(11) 99999-4444', totalOrders: 22, totalSpent: 3200.00, lastOrderAt: new Date().toISOString(), createdAt: new Date(Date.now() - 180 * 86400000).toISOString() },
];

export const mockReservations: Reservation[] = [
    { id: 'r1', customerName: 'Família Rodrigues', customerPhone: '(11) 98888-1111', date: new Date().toISOString().split('T')[0], time: '19:00', partySize: 4, status: 'confirmed', createdAt: new Date().toISOString() },
    { id: 'r2', customerName: 'Casal Lima', customerPhone: '(11) 98888-2222', date: new Date().toISOString().split('T')[0], time: '20:30', partySize: 2, status: 'pending', notes: 'Aniversário', createdAt: new Date().toISOString() },
    { id: 'r3', customerName: 'Bruno Santos', customerPhone: '(11) 98888-3333', date: new Date(Date.now() + 86400000).toISOString().split('T')[0], time: '12:00', partySize: 6, status: 'confirmed', createdAt: new Date().toISOString() },
];

export const mockDashboardMetrics: DashboardMetrics = {
    todayOrders: 48,
    todayRevenue: 5840.50,
    pendingOrders: 3,
    activeReservations: 8,
    weeklyRevenue: [
        { day: 'Seg', revenue: 3200 },
        { day: 'Ter', revenue: 4100 },
        { day: 'Qua', revenue: 3800 },
        { day: 'Qui', revenue: 5200 },
        { day: 'Sex', revenue: 7400 },
        { day: 'Sáb', revenue: 8900 },
        { day: 'Dom', revenue: 5840 },
    ],
    topProducts: [
        { name: 'Filé ao Molho Madeira', count: 34 },
        { name: 'Risoto de Camarão', count: 28 },
        { name: 'Petit Gateau', count: 22 },
        { name: 'Bruschetta Clássica', count: 19 },
        { name: 'Carpaccio de Filé', count: 15 },
    ],
    ordersByType: [
        { type: 'table', count: 28 },
        { type: 'counter', count: 12 },
        { type: 'delivery', count: 8 },
    ],
};

export const formatPrice = (value: number) =>
    value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

export const formatDate = (date: string) =>
    new Date(date).toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' });

export const formatTime = (date: string) =>
    new Date(date).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });

export const timeAgo = (date: string) => {
    const diff = Math.floor((Date.now() - new Date(date).getTime()) / 60000);
    if (diff < 1) return 'agora';
    if (diff < 60) return `${diff}min atrás`;
    return `${Math.floor(diff / 60)}h atrás`;
};

export const orderStatusLabel: Record<string, string> = {
    awaiting_payment: 'Aguardando pagamento',
    pending: 'Aguardando',
    confirmed: 'Confirmado',
    preparing: 'Preparando',
    ready: 'Pronto',
    delivered: 'Entregue',
    cancelled: 'Cancelado',
};

export const orderStatusColor: Record<string, string> = {
    awaiting_payment: 'badge-warning',
    pending: 'badge-warning',
    confirmed: 'badge-primary',
    preparing: 'badge-primary',
    ready: 'badge-success',
    delivered: 'badge-muted',
    cancelled: 'badge-destructive',
};
